import React, { useEffect } from 'react';
import { Breadcrumbs, Link, Skeleton } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { setItemId } from '@/features/table/attachmentsTableSlice';
import { useAttachmentsContext } from '@/context/attachmentsContext';
import { useGetBreadcrumbsQuery } from '@/features/msGraph/msGraphApi';

export const FolderBreadcrumbs = () => {
	const dispatch = useDispatch();

	const { refreshIndicator, itemId, parentItemId } = useSelector(
		(state) => state.attachmentsTable,
	);

	const { clientFolderDriveId } = useAttachmentsContext();

	const {
		data: breadcrumbs,
		isError,
		isLoading,
		isUninitialized,
		refetch,
	} = useGetBreadcrumbsQuery(
		{
			endItemId: itemId,
			startItemId: parentItemId,
			driveId: clientFolderDriveId,
		},
		{ skip: !itemId || !parentItemId || !clientFolderDriveId },
	);

	useEffect(() => {
		if (breadcrumbs) {
			refetch();
		}
	}, [refreshIndicator]);

	if (!itemId || !clientFolderDriveId || isError) {
		return null;
	}

	if (isLoading || isUninitialized) {
		return <Skeleton width='20%' />;
	}

	return (
		<Breadcrumbs separator={<NavigateNextIcon fontSize='small' />} sx={{ mb: '0.5em' }}>
			{(breadcrumbs ?? []).map((b, i) => (
				<Link
					component='button'
					key={`breadcrumb-${b.id}`}
					underline='hover'
					variant='task_updated'
					color={i !== breadcrumbs.length - 1 ? 'inherit' : 'textPrimary'}
					sx={(theme) => ({
						'&:hover': {
							color: theme.palette.primary.main,
						},
					})}
					onClick={() => {
						if (itemId !== b.id) {
							dispatch(setItemId(b.id));
						}
					}}
				>
					{b.name}
				</Link>
			))}
		</Breadcrumbs>
	);
};
